document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.departments__whatsapp-btn')) {
        var whatsappButtons = document.querySelectorAll('.departments__whatsapp-btn');

        whatsappButtons.forEach(function(whatsappButton) {
            whatsappButton.addEventListener('click', function () {
                var number = whatsappButton.getAttribute('data-number');
                var message = "";
                var url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
                window.open(url, '_blank');
            });
        });
    }

    if (document.querySelector('.btn-depart--whatsapp')) {
        var chatButtons = document.querySelectorAll('.btn-depart--whatsapp');

        chatButtons.forEach(function(chatButton) {
            chatButton.addEventListener('click', function () {
                var number = chatButton.getAttribute('data-number'); // Użyj odpowiedniego atrybutu, jeśli jest inny
                var message = "";
                var url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
                window.open(url, '_blank');
            });
        });
    }

    if (document.querySelector('.intro-landing__whatsapp-btn')) {
        var chatButtons = document.querySelectorAll('.intro-landing__whatsapp-btn');

        chatButtons.forEach(function(chatButton) {
            chatButton.addEventListener('click', function () {
                var number = chatButton.getAttribute('data-number'); // Użyj odpowiedniego atrybutu, jeśli jest inny
                var message = "";
                var url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
                window.open(url, '_blank');
            });
        });
    }
});
